import React, { Fragment, Component } from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  MdDeleteForever,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdEdit,
} from "react-icons/md";

import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";

import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { getAuthUser } from "../GeneralFunctions";

import * as Server from "../Server";
import ParentCampEdit from "./ParentCampEdit";

let user = {};
let selectedCampId = null;

class ParentCamp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      totalCamps: 0,
      pages: 0,
      pageNumbers: [],
      camp: {},
      camps: [],
      editCamp: false,
      showLoader: false,
      campEditPage: false,
      removeCampConfirmationModal: false,
    };
  }

  componentDidMount() {
    user = getAuthUser();
    this.getCamps();
  }

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "/camp/parentCampList",
        method: "POST",
        data: {
          page,
          pageLimit,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          camps: response.camps,
          totalCamps: response.totalCamps,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  removeCamp = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: `camp/deleteParentCamp`,
        method: "POST",
        data: {
          campId: selectedCampId,
        },
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
        this.getCamps();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getCamps();
    });
  };

  toggleremoveCampConfirmationModal = async (id) => {
    if (id) selectedCampId = id;
    this.setState({
      removeCampConfirmationModal: !this.state.removeCampConfirmationModal,
    });
  };

  renderCampEditPage = (camp, key) => {
    this.setState({
      camp,
      campEditPage: true,
      editCamp: key,
    });
  };

  closeModal = async () => {
    this.setState({ removeCampConfirmationModal: false });
  };

  closeCampEditPage = async (obj) => {
    this.setState({ campEditPage: false });
    this.getCamps();
  };

  render() {
    return (
      <Fragment>
        {this.state.campEditPage ? (
          <ParentCampEdit
            camp={this.state.camp}
            campEditKey={this.state.editCamp}
            closeCampEditPage={(event) => this.closeCampEditPage(event)}
          ></ParentCampEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Parent Event"
              breadcrumbs={[{ name: "Parent Event", active: true }]}
            >
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader>
                      <Row>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex">
                            <div sm={4} className="mt-2 pr-2">
                              <Label>Shown</Label>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                name="pageLimit"
                                value={this.state.limit}
                                onChange={(event) => {
                                  this.refreshPagination(1, event.target.value);
                                  this.context.updateState({
                                    limit: event.target.value,
                                  });
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </Input>
                            </div>
                            <div sm={4} className="mt-2 pl-2">
                              <Label>entries</Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-center">
                            <div className="mt-2 pr-2">
                              <Label>
                                Showing{" "}
                                {!this.state.totalCamps
                                  ? 0 + " "
                                  : this.state.page * this.state.limit -
                                    (this.state.limit - 1) +
                                    " "}
                                to{" "}
                                {this.state.page * this.state.limit >
                                this.state.totalCamps
                                  ? this.state.totalCamps
                                  : this.state.page * this.state.limit}{" "}
                                of {this.state.totalCamps}
                              </Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <div sm={4} className="pr-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page <= 1}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page - 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                              </Button>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                value={this.state.page}
                                name="filter"
                                onChange={(event) => {
                                  this.refreshPagination(
                                    event.target.value,
                                    this.state.limit
                                  );
                                }}
                              >
                                {this.state.pageNumbers.length !== 0 ? (
                                  this.state.pageNumbers.map(
                                    (pageNumber, index) => (
                                      <option value={pageNumber} key={index}>
                                        {pageNumber}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={0}>0</option>
                                )}
                              </Input>
                            </div>
                            <div sm={4} className="pl-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page >= this.state.pages}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page + 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Button
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={(event) => this.renderCampEditPage({}, false)}
                      >
                        Add Event
                      </Button>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.camps && this.state.camps.length > 0 ? (
                            this.state.camps.map((camp, index) => (
                              <tr key={index}>
                                <td>{camp.name}</td>
                                <td>
                                  <Button
                                    style={{ marginRight: "10px" }}
                                    onClick={(event) => {
                                      this.renderCampEditPage(camp, true);
                                    }}
                                  >
                                    <MdEdit size="20px" />
                                  </Button>
                                  <Button
                                    style={{ marginRight: "10px" }}
                                    onClick={(event) =>
                                      this.toggleremoveCampConfirmationModal(
                                        camp._id
                                      )
                                    }
                                  >
                                    <MdDeleteForever size="20px" />
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">
                                No events found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                    {this.state.removeCampConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeCampConfirmationModal}
                        toggle={(event) =>
                          this.toggleremoveCampConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleremoveCampConfirmationModal()
                          }
                        ></ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this event ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleremoveCampConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.toggleremoveCampConfirmationModal();
                              this.removeCamp();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}

export default ParentCamp;
